// REFS:
// About Events: https://support.google.com/analytics/answer/1033068?hl=pt-BR
// Event Tracking: https://developers.google.com/analytics/devguides/collection/analyticsjs/events?hl=pt-br#overview

const trackAnalyticsEvent = (context, category, action, label) => {
  context.$ga.query('send', 'event', {
    'eventCategory': category,
    'eventAction': action,
    'eventLabel': label,
    hitCallback: function () {
      // console.log(`Event sent: ${category}, ${action}, ${label}`)
    },
    hitCallbackFail: function () {
      // console.log('Unable to send Google Analytics data!')
    }
  })
}

export {
  trackAnalyticsEvent
}



// WEBPACK FOOTER //
// ./client/utils/analytics.js